import { DbMongoSerializationBaseInfos } from "./db-mongo-serialization-base-infos";

import { DbUserInfos } from "./db-user-infos";

export class DbObjectCreateOrUpdateInfos extends DbMongoSerializationBaseInfos {
  userId: number | null = 0;
  date: Date = new Date("2022-09-27T14:41:36.5477874+02:00"); // TODO : can we do better than that ?
  endDate: Date | null = null;
  message: string | null = null;
  comment: string | null = null;
  user: DbUserInfos | null = null;
  userName: string | null = "Unknown";

  constructor(init?: Partial<DbObjectCreateOrUpdateInfos>) {
    super();
    Object.assign(this, init);
  }
}
